// extracted by mini-css-extract-plugin
export default {"donut-chart":"donut-chart_donut-chart__+I46r","donut-chart__center-label":"donut-chart_donut-chart__center-label__hHrwD"};